import { IClientControlOption } from '@/Interfaces/ControlOption.interface';
import AutocompleteControl from '@/components/Form/AutocompleteControl';
import { getFieldErrorProps } from '@/helpers/form';
import { useAppSelector } from '@/store/hooks';
import { selectRibeyeAllClients } from '@/store/selectors/sharedApi.selectors';
import { Button, InputLabel, TextField } from '@mui/material';
import { useMemo } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

interface IProps {
  openAdvertiserModal: () => void;
  disabled?: boolean;
}

const AgencyInfo = ({ openAdvertiserModal, disabled }: IProps) => {
  const { control } = useFormContext();

  const clients = useAppSelector(selectRibeyeAllClients);

  const selectedClient: IClientControlOption | null = useWatch({ control, name: 'client' });

  const advertisersOptions = useMemo(() => {
    if (selectedClient?.advertisers) {
      return selectedClient?.advertisers;
    }
    if (selectedClient && !selectedClient?.advertisers) {
      const client = clients.find(({ value }) => selectedClient.value === value);
      return client?.advertisers || [];
    }
    return [];
  }, [selectedClient, clients]);

  return (
    <>
      <div>
        <InputLabel htmlFor='name'>
          Name<span className='text-[#fe4033]'>*</span>
        </InputLabel>
        <Controller
          name='name'
          control={control}
          rules={{
            required: {
              value: true,
              message: 'Please enter name',
            },
          }}
          disabled={disabled}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              fullWidth
              placeholder='Enter Agency Name'
              id='name'
              {...getFieldErrorProps(fieldState)}
            />
          )}
        />
      </div>
      <div className='mt-4'>
        <InputLabel htmlFor='client'>
          Client<span className='text-[#fe4033]'>*</span>
        </InputLabel>
        <AutocompleteControl
          name='client'
          required
          control={control}
          options={clients}
          id='client-select'
          placeholder='Select client'
          disabled={disabled}
        />
      </div>
      <div className='mt-4'>
        <InputLabel htmlFor='advertisers'>Advertisers</InputLabel>
        <AutocompleteControl
          name='advertisers'
          id='advertisers-select'
          options={advertisersOptions}
          control={control}
          placeholder='Select advertisers'
          disabled={!selectedClient || disabled}
          multiple
        />
        <Button
          sx={{ height: 40, width: 200, marginTop: 2 }}
          color='primary'
          variant='contained'
          disabled={!selectedClient || disabled}
          onClick={openAdvertiserModal}
        >
          + Create new Advertiser
        </Button>
      </div>
    </>
  );
};

export default AgencyInfo;
